module.exports = __webpack_public_path__ + "img/firo.583bcbd2.svg";